export default "__VITE_ASSET__4fe19250__"